import React from 'react'
import { IndexLink, Link } from 'react-router'
import PropTypes from 'prop-types'
import './PageLayout.scss'

export const PageLayout = ({ children }) => (
  <span style={{ width: '100%', height: '100%' }}>
    <header className='header'>
      <div className='top-bar'>
        <div className='container'>
          <div className='content-holder d-flex right'>
            <div className='CTAs'><a href='#' className='login'><i className='fa fa-sign-in' /><span className='d-none d-md-inline'>Login</span></a><a href='#' className='login'> <i className='fa fa-user' /><span className='d-none d-md-inline'>Register</span></a></div>
          </div>
        </div>
      </div>
      <nav className='navbar navbar-expand-lg'>
        <div className='container'>
          <a href='index.html' className='text-primary'>Mike's Cheap Tickets</a>
        </div>
      </nav>
    </header>
    {children}
    <footer className='main-footer'>

      <div className='copyrights text-center'>
        <p>&copy; 2017 <span className='text-primary'>Mike's Cheap Tickets.</span> All Rights Reserved.</p>
      </div>
      {
      //   <div className='container'>
      //     <div className='row'>
      //       <div className='about col-md-4'>
      //         <div className='logo'><img src='img/logo-footer.png' alt='...' /></div>
      //         <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
      //       </div>
      //       <div className='site-links col-md-4'>
      //         <h3>Useful links</h3>
      //         <div className='menus d-flex'>
      //           <ul className='list-unstyled'>
      //             <li> <a href='index.html'>Homepage</a></li>
      //             <li> <a href='category.html'>Listings detail</a></li>
      //             <li> <a href='detail.html'>Listing detail</a></li>
      //             <li> <a href='blog.html'>Blog</a></li>
      //             <li> <a href='post.html'>Post</a></li>
      //             <li> <a href='#'>Privacy policy </a><span className='badge badge-secondary text-uppercase ml-1'>Soon</span></li>
      //           </ul>
      //           <ul className='list-unstyled'>
      //             <li> <a href='text.html'>Text page</a></li>
      //             <li> <a href='404.html'>404 - Not found</a></li>
      //             <li> <a href='contact.html'>Contact</a></li>
      //             <li> <a href='#'>Pricing </a><span className='badge badge-secondary text-uppercase ml-1'>Soon</span></li>
      //           </ul>
      //         </div>
      //       </div>
      //       <div className='contact col-md-4'>
      //         <h3>Contact  us</h3>
      //         <div className='info'>
      //           <p>53 Broadway, Broklyn, NY 11249</p>
      //           <p>Phone: (020) 123 456 789</p>
      //           <p>Email: <a href='mailto:info@company.com'>Info@Company.com</a></p>
      //           <ul className='social-menu lisy-inline'>
      //             <li className='list-inline-item'><a href='#' target='_blank' title='Facebook'><i className='fa fa-facebook' /></a></li>
      //             <li className='list-inline-item'><a href='#' target='_blank' title='Twitter'><i className='fa fa-twitter' /></a></li>
      //             <li className='list-inline-item'><a href='#' target='_blank' title='Pinterest'><i className='fa fa-pinterest' /></a></li>
      //             <li className='list-inline-item'><a href='#' target='_blank' title='Instagram'><i className='fa fa-instagram' /></a></li>
      //             <li className='list-inline-item'><a href='#' target='_blank' title='Vimeo'><i className='fa fa-vimeo' /></a></li>
      //           </ul>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
     }

    </footer>
  </span>
)
PageLayout.propTypes = {
  children: PropTypes.node,
}

export default PageLayout



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/PageLayout.js